import React, { ReactNode } from "react";

export function SvgButton({
  children,
  title,
  className,
  dataButtonKey,
  onClick,
  active = true,
  size = "medium",
  color = "black",
}: {
  children: ReactNode;
  title: string;
  className?: string;
  onClick: (event?: React.MouseEvent<HTMLDivElement>) => void;
  active?: boolean;
  dataButtonKey?: string;
  size?: "x-small" | "small" | "medium" | "large" | "x-large";
  color?: string;
}) {
  return (
    <div
      className={`svg-button ${className} ${size} ${active ? "active" : ""}`}
      style={{ color: active ? color : null }}
      data-button-key={dataButtonKey ?? title}
      title={title}
      onClick={active ? onClick : () => null}
    >
      {children}
    </div>
  );
}
